const utils = {
	/**获取一个值的数据类型 */
	dataType(param) {
		return Object.prototype.toString.call(param);
	},

	/**数组去重 Set */
	uniqueSet(array) {
		return [...new Set(array)];
	},

	/**数组去重 filter */
	uniqueFilter(array) {
		let obj = [];
		return array.filter(ele => {
			if (!obj[ele]) {
				obj[ele] = true;
				return true;
			}
		})
	},

	/**数组去重 forEach */
	uniqueForEach(array) {
		let result = [];
		array.forEach(ele => {
			if (result.indexOf(ele) == -1) {
				result.push(ele);
			}
		})
		return result;
	},

	/**字符串去重 */
	stringUnique(str) {
		return str.replace(/(w)1+/g, "$1");
	}
}

export default utils;
